import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createPaginationContainer } from 'react-relay';
import TopBarNotification from '../../../shared/components/common/TopBarNotification';
import { FREELANCER_APP } from '../../../shared/services/constants';

const TopBarFreelancerNotification = props => {
  const { notifications, relay } = props;

  return <TopBarNotification type={FREELANCER_APP} notifications={notifications} {...relay} />;
};
export default createPaginationContainer(
  TopBarFreelancerNotification,
  {
    notifications: graphql`
      fragment TopBarFreelancerNotification_notifications on Query
      @argumentDefinitions(
        unread: { type: Boolean, defaultValue: true }
        first: { type: "Int", defaultValue: 10 }
        after: { type: "String" }
      ) {
        notifications(unread: $unread, first: $first, after: $after)
          @connection(key: "TopBarFreelancerNotification_notifications") {
          totalCount
          edges {
            node {
              id
              unread
              timesince
              description
              actor {
                name
                representativeImageUrl
                actorType
              }
              extraData {
                targetRelayId
                actionRelayId
                content
                notificationType
                instanceType
                instanceTitle
                action
              }
              reviewAssetComment {
                id
              }
            }
          }
        }
      }
    `
  },
  {
    direction: 'forward',
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        first: count,
        after: cursor,
        unread: fragmentVariables.unread
      };
    },
    query: graphql`
      query TopBarFreelancerNotificationRefetchQuery(
        $unread: Boolean
        $first: Int!
        $after: String
      ) {
        ...TopBarFreelancerNotification_notifications
          @arguments(unread: $unread, first: $first, after: $after)
      }
    `
  }
);
